import axios from 'axios';
import qs from 'query-string';
import constant from '@/utils/constant';
export async function ConditionMchAgentSet(condition, pageHelper) {
  return axios.get('/tp/mch/set?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function AddMchAgentSet(data) {
  return axios.post('/tp/mch/set', qs.stringify(data));
}
export async function GetMchJoinLimit() {
  return axios.get('/tp/agent/limit');
}
export async function GetBankCardJoinLimit() {
  return axios.get('/tp/mch/limit');
}
export async function ConditionGetMchUserList(condition, pageHelper) {
  return axios.get('/tp/user/mch?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function DeleteMchAgentSet(id, paypass) {
  return axios.delete(`/tp/mch/set/${id}?paypass=${paypass}`);
}
export async function DeleteMchUser(id, paypass) {
  return axios.delete(`/tp/user/mch/${id}?paypass=${paypass}`);
}
export async function UpdateMchUser(data) {
  return axios.put(`/tp/user/mch/`, data);
}
export async function DeleteAgentUser(id, paypass) {
  return axios.delete(`/tp/user/agent/${id}?paypass=${paypass}`);
}
export async function ConditionGetMultiAgentList(condition, pageHelper) {
  return axios.get('/tp/user/agent/multi?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function DeleteCnlAgentSet(id, paypass) {
  return axios.delete(`/tp/agent/set/${id}?paypass=${paypass}`);
}
export async function DeleteCnlProductSet(id, paypass) {
  return axios.delete(`/tp/channel/product/${id}?paypass=${paypass}`);
}
export async function ConditionGetCnlAgentSetList(condition, pageHelper) {
  return axios.get('/tp/agent/set?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function ConditionGetAgentSettlementLIst(condition, pageHelper) {
  return axios.get('/tp/agent/settlement?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function PreviewAgentSettlement(op, setMonth, agentId, setType, setId) {
  return axios.post('/tp/agent/settlement', qs.stringify({
    op,
    setMonth,
    agentId,
    setType,
    setId
  }));
}
export async function SetNewMchNeedInfo(cnlId, draftId, accountType, bank, ck, salesAgent) {
  return axios.get('/tp/mch/set/need?' + qs.stringify({
    cnlId,
    draftId,
    accountType,
    bank,
    ck,
    salesAgent
  }));
}
export async function SetExtraFormNeedInfo(cnlTag, formName) {
  return axios.get('/tp/mch/set/from?' + qs.stringify({
    cnlTag,
    formName
  }));
}
export async function MchIncomeSendSms(type) {
  return axios.get('/tp/mch/income/sms?' + qs.stringify({
    type
  }));
}
export async function MchIncomeResetPhone(newPhone, paypass, code) {
  return axios.post('/tp/mch/income/reset/reg_phone', qs.stringify({
    newPhone,
    paypass,
    code
  }));
}
export async function GetDraft(id) {
  return axios.get('/tp/mch/draft?' + qs.stringify({
    id
  }));
}
export async function SaveMchDraft(id, info) {
  return axios.post('/tp/mch/draft?' + qs.stringify({
    id
  }), info);
}
export async function IncomeModifyMchInfo(incomeId, info) {
  return axios.post('/tp/mch/income/modify?' + qs.stringify({
    id: incomeId
  }), info);
}
export async function PersonIncomeModifyMchInfo(incomeId, info) {
  return axios.post('/tp/mch/income/modify/p?' + qs.stringify({
    id: incomeId
  }), info);
}
export async function AgentSwitchMch(mch_id, from_agent_id, to_agent_id, paypass) {
  return axios.post('/tp/mch/income/agent/switch', qs.stringify({
    to_agent_id,
    from_agent_id,
    mch_id,
    paypass
  }));
}
export async function AgentInputMch(income_id, plat_mch_id, bank_name, bank_no, bank_proto_no, mch_rate) {
  return axios.post('/tp/mch/income/agent/input', qs.stringify({
    income_id,
    plat_mch_id,
    bank_name,
    bank_no,
    mch_rate,
    bank_proto_no
  }));
}
export async function GetMchDraft(id) {
  return axios.get('/tp/mch/draft?' + qs.stringify({
    id
  }));
}
export async function NewMchWithRelationCnl(draftId, salesAgent) {
  return axios.post('/tp/mch/set/v2', qs.stringify({
    id: draftId,
    salesAgent: salesAgent ? '1' : '0'
  }));
}
export async function NewPersonCompanyMchVerify(data) {
  return axios.post('/tp/mch/set/v2/verify', qs.stringify(data));
}
export async function SelectQueryLianLianBankSubNum(bankCode, cityCode, bankSubName) {
  return axios.get('/tp/mch/set/llbksn?' + qs.stringify({
    bankCode,
    cityCode,
    bankSubName
  }));
} // 此处确保2秒内的randomKey都一样，确保 两个组件合并时 用的key是一样的

let cacheRandomVal = undefined;
export async function GetLianLianPwdRandomKey(incomeId, cnlId) {
  if (cacheRandomVal) {
    // console.log("取得缓存randomVal")
    // console.log(cacheRandomVal.data.data)
    return cacheRandomVal;
  } // console.log("获取randomKey:" + cacheRandomVal)
  // return axios.get('/tp/mch/set/llpwdrk?' + qs.stringify({ incomeId, cnlId }));


  const res = await axios.get('/tp/mch/set/llpwdrk?' + qs.stringify({
    incomeId,
    cnlId
  }));

  if (cacheRandomVal == undefined && res.data.code == constant.SysSuc) {
    cacheRandomVal = res;
    setTimeout(() => {
      // console.log("清理cache random");
      cacheRandomVal = undefined;
    }, 2200);
  }

  return res;
}
export async function GetLianLianRegSms(phone, userId, cnlId) {
  return axios.get('/tp/mch/set/llregsms?' + qs.stringify({
    phone,
    userId,
    cnlId
  }));
}
export async function GetGrgMchRegPersonSms(incomeId, phone, sceneType) {
  return axios.get('/tp/mch/grg/reg_sms?' + qs.stringify({
    incomeId,
    phone,
    sceneType
  }));
}
export async function GrgNewPersonPrivateMch(data) {
  return axios.post('/tp/mch/grg/white', data);
}
export async function GrgPersonPrivateMchModifyCard(data) {
  return axios.put('/tp/mch/grg/white', data);
}
export async function GetGrgPersonWhiteMchList(incomeId) {
  return axios.get('/tp/mch/grg/white?' + qs.stringify({
    incomeId
  }));
}
export async function GetLianLianRegSmsCheck(phone, userId, cnlId, code) {
  return axios.get('/tp/mch/set/llregsms/ck?' + qs.stringify({
    phone,
    userId,
    cnlId,
    code
  }));
}
export async function GetChannelList() {
  return axios.get('/tp/channel/');
}
export async function ConditionChannelList(condition, pageHelper) {
  return axios.get('/tp/channel/l?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function ChannelDetail(id) {
  return axios.get('/tp/channel/detail?id=' + id);
}
export async function ConditionMchIncomeList(condition, pageHelper) {
  return axios.get('/tp/mch/income?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function GetMchCompIncomeRelationList(mchId = '') {
  return axios.get('/tp/mch/income/relation?' + qs.stringify({
    mchId
  }));
}
export async function GetMchCompIncomeSalesAgentList(agentId = '') {
  return axios.get('/tp/mch/income/salesAgent?' + qs.stringify({
    agentId
  }));
}
export async function ConditionMchCompIncomeSalesAgentList(condition, pageHelper) {
  return axios.get('/tp/mch/income/salesAgents?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function MchSwitchIncome(id) {
  return axios.post('/tp/mch/income/switch', qs.stringify({
    id
  }));
}
export async function ResetIncome(incomeId) {
  return axios.put('/tp/mch/draft/reset?' + qs.stringify({
    id: incomeId
  }));
}
export async function ArchiveIncome(incomeId) {
  return axios.put('/tp/mch/draft/archive?' + qs.stringify({
    id: incomeId
  }));
}
export async function UnArchiveIncome(incomeId) {
  return axios.put('/tp/mch/draft/unArchive?' + qs.stringify({
    id: incomeId
  }));
}
export async function GetIncomePersonMchList(cnlTag) {
  return axios.get('/tp/mch/income/pmch?cnlTag=' + cnlTag);
}
export async function GetIncomePersonCardList(incomeId) {
  return axios.get('/tp/mch/income/pcard?id=' + incomeId);
}
export async function QueryIncomeStat(incomeId) {
  return axios.get('/tp/mch/income/stat?' + qs.stringify({
    id: incomeId
  }));
}
export async function QueryIncomeStatWallet(incomeId) {
  return axios.get('/tp/mch/income/stat/wallet?' + qs.stringify({
    id: incomeId
  }));
}
/**
 *
 * @param incomeId 只有代理查询给值才有意义
 * @constructor
 */

export async function QueryIncomeStatVirtualCompCard(incomeId = 0) {
  return axios.get('/tp/mch/income/stat/vcb?' + qs.stringify({
    incomeId
  }));
}
export async function QueryPersonIncomeStat(incomeId) {
  return axios.get('/tp/mch/income/p/stat?' + qs.stringify({
    id: incomeId
  }));
}
export async function IncomeBindMch(incomeId) {
  return axios.post('/tp/mch/income/bind', qs.stringify({
    id: incomeId
  }));
}
export async function IncomeBindMchSendEmail(incomeId, openInfo) {
  return axios.post('/tp/mch/income/bind/email', qs.stringify({
    id: incomeId,
    openInfo
  }));
}
export async function IncomeAssociateBindMch(incomeId, mchAccount) {
  return axios.post('/tp/mch/income/assoc/bind', qs.stringify({
    id: incomeId,
    mchAccount
  }));
}
export async function IncomeUnBindMch(incomeId) {
  return axios.post('/tp/mch/income/unbind', qs.stringify({
    id: incomeId
  }));
}
export async function IncomeNewVirtualAccount(incomeId, bankTag, tag) {
  return axios.post('/tp/mch/income/cvb', qs.stringify({
    id: incomeId,
    bankTag,
    tag
  }));
}
export async function IncomeNewInsteadPayAgree(incomeId) {
  return axios.get('/tp/mch/set/llpayagree?incomeId=' + incomeId);
}
export async function IncomeNewCard(incomeId, cardNo, cardPhone, password, randomKey) {
  return axios.post('/tp/mch/income/bindCard', qs.stringify({
    id: incomeId,
    cardNo,
    cardPhone,
    password,
    randomKey
  }));
}
export async function IncomeNewCardVerify(incomeId, cardNo, // orderNo,
// token,
verifyCode, bindRes) {
  return axios.post('/tp/mch/income/bindCard/verify', qs.stringify({
    id: incomeId,
    cardNo,
    ...bindRes,
    verifyCode
  }));
}
export async function IncomeChangeRegPhone(incomeId, regPhoneNew, password, randomKey) {
  return axios.post('/tp/mch/income/changePhone', qs.stringify({
    id: incomeId,
    regPhoneNew,
    password,
    randomKey
  }));
}
export async function IncomeChangeRegPhoneVerify(incomeId, verifyCode, bindRes) {
  return axios.post('/tp/mch/income/changePhone/verify', qs.stringify({
    id: incomeId,
    ...bindRes,
    verifyCode
  }));
}
export async function IncomeResetPassword(incomeId) {
  return axios.post('/tp/mch/income/resetpassword', qs.stringify({
    incomeId
  }));
}
export async function IncomeResetPasswordVerify(incomeId, verifyCode, bindRes, randomKey, password) {
  return axios.post('/tp/mch/income/resetpassword/verify', qs.stringify({ ...bindRes,
    incomeId,
    verifyCode,
    randomKey,
    password
  }));
}
export async function IncomeChangePayPass(incomeId, password, passwordNew, randomKey) {
  return axios.post('/tp/mch/income/cgPayPass', qs.stringify({
    incomeId,
    password,
    passwordNew,
    randomKey
  }));
}
export async function IncomeModifyProductFee(incomeId) {
  return axios.post('/tp/mch/income/mod/fee', qs.stringify({
    id: incomeId
  }));
}
export async function ConditionBankCardList(condition, pageHelper) {
  return axios.get('/tp/card?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function UpdateBankCardStatus(id, status) {
  return axios.put('/tp/card', qs.stringify({
    id,
    status
  }));
}
export async function ConditionFundOrderList(condition, pageHelper) {
  return axios.get('/tp/order?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function ConditionFundOrderListExport(condition) {
  return axios.get('/tp/order/export?' + qs.stringify(condition));
}
export async function FundOrderCardInfo(orderNo, cardId) {
  return axios.get('/tp/order/card?' + qs.stringify({
    orderNo,
    cardId
  }));
}
export async function ConditionSplitOrderList(condition, pageHelper) {
  return axios.get('/tp/split/order?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function MyDashData() {
  return axios.get('/tp/user/dash');
}
export async function ChartData(year, agentId, mchId, incomeId, searchMemo) {
  return axios.get('/tp/chart?' + qs.stringify({
    year,
    agentId,
    mchId,
    incomeId,
    searchMemo
  }));
}
export async function ChartScatterData(year, month, agentId, queryMemo) {
  return axios.get('/tp/chart/scatter?' + qs.stringify({
    year,
    month,
    agentId,
    filterMemo: queryMemo ? '1' : '0'
  }));
}
export async function ChartPerformanceRankData(start, end, agentId, filterMemo, searchMemo) {
  return axios.get('/tp/chart/rank?' + qs.stringify({
    start,
    end,
    agentId,
    filterMemo: filterMemo ? '1' : '0',
    searchMemo
  }));
}
export async function ChartECommerceShareData(year, month, agentId, mchId, incomeId, searchMemo, cnlTag) {
  return axios.get('/tp/chart/e/share?' + qs.stringify({
    year,
    month,
    agentId,
    mchId,
    incomeId,
    searchMemo,
    cnlTag
  }));
}
export async function ChartOpenMchData(year, month, agentId) {
  return axios.get('/tp/chart/mch?' + qs.stringify({
    year,
    month,
    agentId
  }));
}
export async function MyCompCardList() {
  return axios.get('/tp/user/card');
} // 此接口全平台通用

export async function LianLianVirtualTransToWallet(smsCode = '', incomeId = 0) {
  return axios.post('/tp/mch/set/llvt', qs.stringify({
    smsCode,
    incomeId
  }));
}
export async function MchWalletWithdraw(inCardId, amount, password, randomKey, smsCode) {
  return axios.post('/tp/mch/income/withdraw', qs.stringify({
    amount,
    inCardId,
    password,
    randomKey,
    smsCode
  }));
}
export async function YpCompInstead(cardId, cardName, bank, amount, password, smsCode, insteadNote) {
  return axios.post('/tp/mch/yp/comp/instead', qs.stringify({
    cardId,
    cardName,
    bank,
    amount,
    password,
    smsCode,
    insteadNote
  }));
}
export async function PlatWithdraw(cnlId, paypass, amount) {
  return axios.post('/tp/mch/plat/withdraw', qs.stringify({
    cnlId,
    paypass,
    amount
  }));
}
export async function PlatStatement(cnlId, operate, dayVal) {
  return axios.post('/tp/mch/plat/statement', qs.stringify({
    cnlId,
    operate,
    date: dayVal
  }));
} //备用 提现免密后关闭

export async function MchWalletWithdrawLL(incomeId, inCardId, amount, password, randomKey) {
  return axios.post('/tp/mch/set/llwithdraw', qs.stringify({
    incomeId,
    amount,
    inCardId,
    password,
    randomKey
  }));
}
export async function MchWalletWithdrawYp(incomeId, inCardId, amount, password) {
  return axios.post('/tp/mch/yp/withdraw', qs.stringify({
    incomeId,
    amount,
    inCardId,
    password
  }));
}
export async function LianLianOrderSecondCheck(incomeId, orderNo, code) {
  return axios.post('/tp/mch/set/llodsms/ck', qs.stringify({
    incomeId,
    orderNo,
    code
  }));
}
export async function MchWalletInsteadPay(inCardName, inCardNo, inCardBankCode, inCardBankSubNo, amount, password, randomKey, smsCode, insteadNote, compBankCode = '', compBankSubCode = '', isComp = false) {
  return axios.post('/tp/mch/income/insteadpay', qs.stringify({
    inCardName,
    inCardNo,
    inCardBankCode,
    inCardBankSubNo,
    amount,
    password,
    randomKey,
    smsCode,
    compBankCode,
    compBankSubCode,
    insteadNote,
    isComp: isComp ? '1' : '0'
  }));
}
export async function MchWalletInsteadPay2Elements(inCardName, inCardNo, inCardBankCode, inCardBankSubNo, amount, password, randomKey, smsCode, insteadNote) {
  return axios.post('/tp/mch/income/insteadpay2', qs.stringify({
    inCardName,
    inCardNo,
    inCardBankCode,
    inCardBankSubNo,
    amount,
    password,
    randomKey,
    smsCode,
    insteadNote
  }));
}
export async function MchWalletSupplyInsteadPay(inCardName, inCardNo, insteadSupply, inCardBankType, inCardBankCode, inCardBankSubNo, amount, password, randomKey, smsCode, insteadNote) {
  return axios.post('/tp/mch/income/supply-insteadpay', qs.stringify({
    inCardName,
    inCardNo,
    insteadSupply,
    inCardBankType,
    inCardBankCode,
    inCardBankSubNo,
    amount,
    password,
    randomKey,
    smsCode,
    insteadNote
  }));
}
export async function MchWalletSupplyWithdraw(inCardId, withdrawSupply, amount, password, randomKey, smsCode, insteadNote) {
  return axios.post('/tp/mch/income/supply-withdraw', qs.stringify({
    withdrawSupply,
    inCardId,
    amount,
    password,
    randomKey,
    smsCode,
    insteadNote
  }));
}
export async function MchOpenWalletInsteadPay2(id, mch_name) {
  return axios.put('/tp/mch/income/insteadpay2', qs.stringify({
    id,
    mch_name
  }));
}
export async function MchWalletBathInsteadPay(file, password, smsCode) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('password', password);
  formData.append('smsCode', smsCode);
  return axios.post('/tp/mch/income/insteadpay/batch', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export async function MchWalletBathInsteadPay2Elements(file, password, smsCode) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('password', password);
  formData.append('smsCode', smsCode);
  return axios.post('/tp/mch/income/insteadpay/batch2', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export async function MchReceiptGet(tradeNo) {
  return axios.post('/tp/mch/income/receipt', qs.stringify({
    tradeNo
  }));
}
export async function GetQiChaChaCompDetail(compName) {
  return axios.get('/tp/mch/set/qcc?name=' + compName);
}
export async function GetFileOcrInfo(fileId, fileType) {
  // per leg
  return axios.post('/tp/file/ocr/', qs.stringify({
    fileId,
    fileType
  }));
}
export async function ConditionMchProtocolList(condition, pageHelper) {
  return axios.get('/tp/prot/?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function UpdateFileProtocol(incomeId, pfType, protocols) {
  return axios.put('/tp/prot/', qs.stringify({
    incomeId,
    pfType,
    protocols: JSON.stringify(protocols)
  }));
}
export async function CancelMchESignProtocol(incomeId) {
  return axios.delete('/tp/prot/eSign/' + incomeId);
}
export async function NewMchESignProtocol(incomeId, signUser, signAuthType, compAuthType, fee500, fee1000, fee5000, fee10000) {
  return axios.post('/tp/prot/eSign', qs.stringify({
    incomeId,
    signUser,
    signAuthType,
    compAuthType,
    fee500,
    fee1000,
    fee5000,
    fee10000
  }));
}
export async function NewMchESignUrgeSms(incomeId) {
  return axios.post('/tp/prot/eSign/sms', qs.stringify({
    incomeId
  }));
}
export async function GetMchESignUrgeLink(incomeId) {
  return axios.get('/tp/prot/urge?incomeId=' + incomeId);
}
export async function ReviewMchProtocol(incomeId, eSign) {
  return axios.put('/tp/prot/review', qs.stringify({
    incomeId,
    eSign
  }));
}
export async function GetMyProtocol() {
  return axios.get('/tp/prot/my');
}
export async function GetMchProtocol(incomeId) {
  return axios.get('/tp/prot/mch?incomeId=' + incomeId);
}
export async function GetSySConfig() {
  return axios.get('/tp/cfg/');
}
export async function UpdateSySConfig(id, stu, val) {
  return axios.put('/tp/cfg/', qs.stringify({
    id,
    stu,
    val
  }));
}
export async function YpIndividualApply(name, certNo, phone) {
  return axios.post('/tp/mch/yp/individual', qs.stringify({
    name,
    certNo,
    phone
  }));
}
export async function YpIndividualQuery() {
  return axios.get('/tp/mch/yp/individual');
}
export async function YpMainBankQuery() {
  return axios.get('/tp/mch/yp/m/bank');
}
export async function YpBankQuery(cursor, subName) {
  return axios.get('/tp/mch/yp/bank?cursor=' + cursor + '&subName=' + subName);
}
export async function YpVirtualBankVerifySmsSend(incomeId) {
  return axios.get('/tp/mch/yp/vb/sms?incomeId=' + incomeId);
}
export async function YpVirtualBankVerifySmsConfirm(incomeId, authCode) {
  return axios.get('/tp/mch/yp/vb/sms/cf?' + qs.stringify({
    incomeId,
    authCode
  }));
}
export async function DpVirtualBankAccountVerify(amount, incomeId) {
  return axios.post('/tp/mch/dp/vb/verify', qs.stringify({
    amount,
    incomeId
  }));
}
export async function SmbCompValidVerify(amount, incomeId) {
  return axios.post('/tp/mch/smb/cp/verify', qs.stringify({
    amount,
    incomeId
  }));
}
export async function SmbWhiteListApply(inCardName, inCardNo, inCardBankSubName, inCardBankSubNo, inCardType) {
  return axios.post('/tp/mch/smb/white', qs.stringify({
    inCardName,
    inCardNo,
    inCardBankSubName,
    inCardBankSubNo,
    inCardType
  }));
}
export async function FyGetCheckLink(incomeId) {
  return axios.get('/tp/mch/fo/check_link?incomeId=' + incomeId);
}
export async function FyGetPersonCardList(incomeId) {
  return axios.get('/tp/mch/fo/pcard?incomeId=' + incomeId);
}
export async function FyPersonCardCancel(incomeId, cardId) {
  return axios.post('/tp/mch/fo/pcard/cancel', qs.stringify({
    incomeId,
    cardId
  }));
}
export async function FyAgentMchSendAudit(incomeId) {
  return axios.post('/tp/mch/fo/cp/audit', qs.stringify({
    incomeId
  }));
}
export async function FyAgentMchSaveEncrypt(incomeId, pri, pub) {
  return axios.post('/tp/mch/fo/cp/encrypt', qs.stringify({
    incomeId,
    pri,
    pub
  }));
}
export async function DpVirtualBankAccountSmsSend(phone, incomeId, bankCode) {
  return axios.post('/tp/mch/dp/vb/sms', qs.stringify({
    phone,
    incomeId,
    bankCode
  }));
} //广告线索

export async function GetReceiveAdv(adv_type) {
  return axios.get('/tp/adv/r?adv_type=' + adv_type);
}
export async function UpdateAdv(upInfo) {
  return axios.put('/tp/adv', upInfo);
}
export async function FastNewAdv() {
  return axios.post('/tp/adv');
}
export async function ConditionAdv(condition, pageHelper) {
  return axios.get('/tp/adv?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function NewAdvClues(advId, vals) {
  return axios.post('/tp/adv/clues', qs.stringify({
    advId,
    vals
  }));
}
export async function ConditionAdvClues(condition, pageHelper) {
  return axios.get('/tp/adv/clues?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
} //risk

export async function ConditionRisk(condition, pageHelper) {
  return axios.get('/tp/risk?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}
export async function GetReviewInfo(id) {
  return axios.get('/tp/risk/review?' + qs.stringify({
    id
  }));
}
export async function NewReview(id) {
  return axios.post('/tp/risk/review', qs.stringify({
    id
  }));
}
export async function ReviewRes(id, stu, review_info) {
  return axios.put('/tp/risk/review/' + id, qs.stringify({
    stu,
    review_info
  }));
}
export async function ReviewFetch(id) {
  return axios.put('/tp/risk/review/f/' + id);
} //官网线索

export async function ConditionAdvConnect(condition, pageHelper) {
  return axios.get('/tp/cfg/con?' + qs.stringify(pageHelper) + '&' + qs.stringify(condition));
}